import { get, call } from 'vuex-pathify';

export default {
  data: () => ({
    isDataCalculatorLoaded: false,
    isDataCalculatorVisible: false,
  }),
  computed: {
    configurations: get('dataCalculator/configurations'),
    isDataCalculatorModuleEnabled: get('admin/additionalModules@DATA_CALCULATOR_MODULE.enabled'),
    isDataCalculatorSettingsEnabled: get('admin/settingsValues@data_calculator_module_enabled'),
    hasDataCalculatorPermissions() {
      return (
        this.isDataCalculatorModuleEnabled &&
        this.isDataCalculatorSettingsEnabled &&
        this.$store.get('users/toolsPermissions')['DATA_CALCULATOR_MODULE'].main_value > 0
      );
    },
    isDataCalculatorButtonVisible() {
      return (
        this.hasDataCalculatorPermissions && this.configurations.some(config => config.datasource === this.datasource)
      );
    },
    dataCalculatorButton() {
      return this.isDataCalculatorButtonVisible
        ? [
            {
              name: 'dataCalculator',
              icon: 'mdi-calculator-variant',
              disabled: this.isButtonDisabled({
                skipButtons: ['isAddingButtonActive'],
                additionalCondition: !this.isAtLeastOneObjectSelected,
              }),
              tooltip: this.getButtonTooltip({
                isDisabledByAnotherTool: this.isButtonDisabled({ skipButtons: ['isAddingButtonActive'] }),
                condition: this.isAtLeastOneObjectSelected,
                enableTooltip: 'button.dataCalculator',
                disableTooltip: 'button.toDataCalculator',
                requirement: 'button.atLeastOneSelected',
              }),
              fontSize: '19px',
            },
          ]
        : [];
    },
  },
  methods: {
    getDataCalculatorConfigurations: call('dataCalculator/getDataCalculatorConfigurations'),
    openDataCalculator() {
      this.isDataCalculatorLoaded = this.isDataCalculatorVisible = true;
    },
  },
  mounted() {
    if (this.hasDataCalculatorPermissions && !this.configurations.length) this.getDataCalculatorConfigurations();
  },
};
